import React from 'react';

import { Card as OrionCard } from '@iwoca/orion';

export const Card = ({
  title,
  children,
  icon,
  className,
}: {
  title?: React.ReactNode;
  children: React.ReactNode;
  icon?: React.ReactNode;
  className?: string;
}) => {
  return (
    <OrionCard>
      <div className={`w-full p-s ${className}`}>
        <CardHeading icon={icon}>{title}</CardHeading>
        {children}
      </div>
    </OrionCard>
  );
};

const CardHeading = ({
  children,
  icon,
}: {
  children: React.ReactNode;
  icon: React.ReactNode;
}) => {
  if (!children) return null;

  let headerContent: React.ReactNode = children;

  if (typeof children === 'string') {
    headerContent = <h2 className="m-0 p-0">{children}</h2>;
  }

  return (
    <header className="mb-l flex items-center gap-s">
      {icon ? icon : null}
      {headerContent}
    </header>
  );
};
